<template>
  <v-layout row wrap align-start align-content-start class="mb-2">
    <!-- Title and Actions -->
    <v-flex xs12 class="py-0">
      <v-toolbar color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">gavel</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          <router-link :to="{ name: 'XVATRulesSearch' }" class="white--text link dim">{{ messages.label.METADATA_RULES
          }}
          </router-link>
          / {{ messages.label.XPATH_MAPPING }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="showAddMapping">
          <v-icon left>add_circle</v-icon><span>{{ messages.label.ADD_MAPPING }}</span>
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-layout>
      <!-- XPath Mappings List -->
      <v-flex xs8>
        <XPathMappingsList />
      </v-flex>
      <!-- XPath Mapping Details Sheet -->
      <v-flex xs4 class="side-sheet-container mr-2">
        <XPathDetails />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapActions, mapMutations } from "vuex"
import XPathMappingsList from "@/XVAT/XpathMapping/XPathMappingsList"
import XPathDetails from "@/XVAT/XpathMapping/XPathDetails"
import messages from "@/XVAT/messages.json"
import { GET_XPATH_MAPPING_KEYS } from "@/store/constants/action-types"
import {
  SET_SELECTED_XPATH_KEY,
  SET_SHOW_XPATH_DETAILS,
  SET_XPATH_MAPPING_KEYS
} from "@/store/constants/mutation-types"

export default {
  name: "XVATXPathMappingHome",
  components: {
    XPathMappingsList,
    XPathDetails
  },
  data() {
    return {}
  },
  methods: {
    ...mapMutations("xvat", [
      SET_SELECTED_XPATH_KEY,
      SET_SHOW_XPATH_DETAILS,
      SET_XPATH_MAPPING_KEYS
    ]),
    ...mapActions("xvat", [
      GET_XPATH_MAPPING_KEYS
    ]),

    /**
     * Display side sheet to add a new provider group
     */
    showAddMapping() {
      this.SET_SHOW_XPATH_DETAILS(true)
      this.SET_SELECTED_XPATH_KEY({})
    },

    /**
     * Retreive XPath Mapping Keys
     */
    loadXPathMappingKeys() {
      this.GET_XPATH_MAPPING_KEYS()
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
  },
  beforeRouteLeave(to, from, next) {
    //Clear out state data
    this.SET_SELECTED_XPATH_KEY({})
    this.SET_SHOW_XPATH_DETAILS(false)
    this.SET_XPATH_MAPPING_KEYS([])
    next()
  },
  /**
   * Triggered on first entry in to the route /xvat/xpath-mapping
   * @param {object} to
   * @param {object} from
   * @param {Function} next
   */
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadXPathMappingKeys(to.params.id)
    })
  }
}
</script>

<style lang="scss">
.side-sheet-container {
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/XpathMapping/XVATXPathMappingHome.vue